import { createChunksMatcher } from '../createChunksMatcher';
import { createChunk } from '../Chunks';
export function withStatus(maybeResolvableStatus, child) {
    return createChunksMatcher(maybeResolvableStatus, child, function (status, request) {
        return status ? [createChunk('status', request, { status: status })] : [];
    });
}
//# sourceMappingURL=withStatus.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/navi/dist/es/matchers/withStatus.js
// module id = 109
// module chunks = 0